/**
 * timeFilter — Iter80 (shared between Tableau, Rapports, Alertes).
 *
 * Presets mirror the Rapports tab spec (Dernière heure, Aujourd'hui,
 * Hier, 24 h, 7 J, 30 J, 90 J, custom). `buildTimeParams` produces the
 * exact query-string shape every backend endpoint that supports time
 * filtering already understands: `{preset, since?, until?}`.
 */

export const TIME_PRESETS = [
  { id: "1h",         label: "Dernière heure" },
  { id: "24h",        label: "Dernières 24 heures" },
  { id: "today",      label: "Aujourd'hui" },
  { id: "yesterday",  label: "Hier" },
  { id: "7d",         label: "7 derniers jours" },
  { id: "30d",        label: "30 derniers jours" },
  { id: "90d",        label: "90 derniers jours" },
  { id: "custom",     label: "Période personnalisée" },
];

// Short labels used inside compact chip rows (admin toolbars).
export const TIME_PRESET_SHORT = {
  "1h":        "1 h",
  "24h":       "24 h",
  "today":     "Aujourd'hui",
  "yesterday": "Hier",
  "7d":        "7 J",
  "30d":       "30 J",
  "90d":       "90 J",
  "custom":    "Custom",
};

export const DEFAULT_PRESET = "24h";

/**
 * Build the query-parameter object every server endpoint that filters
 * by time accepts. Returns exactly what the caller should spread into
 * the axios `params` payload.
 *
 * @param {string} preset       preset id
 * @param {string} customSince  ISO-compatible datetime-local string
 * @param {string} customUntil  ISO-compatible datetime-local string
 * @returns {{preset:string, since?:string, until?:string}}
 */
export const buildTimeParams = (preset, customSince, customUntil) => {
  if (preset !== "custom") return { preset };
  const p = { preset: "custom" };
  if (customSince) p.since = new Date(customSince).toISOString();
  if (customUntil) p.until = new Date(customUntil).toISOString();
  return p;
};

/** Human-readable French summary of the current selection — used in
 *  result-count strings ("18 alertes trouvées · 7 derniers jours"). */
export const describeTimeSelection = (preset, customSince, customUntil) => {
  if (preset === "custom") {
    const s = customSince ? new Date(customSince).toLocaleString("fr-FR") : "—";
    const u = customUntil ? new Date(customUntil).toLocaleString("fr-FR") : "maintenant";
    return `${s} → ${u}`;
  }
  return TIME_PRESETS.find((p) => p.id === preset)?.label || preset;
};
